import {Component, Input, OnInit, Output, EventEmitter, Injector} from '@angular/core';
import {NgxFilterBaseComponent} from "../ngx-filter-base-component";
import {NgxDateFilter} from "./ngx-date-filter";
import {Filter, FilterDateTimeOptions} from "../../ngx-types";

@Component({
  selector: 'ngx-date',
  templateUrl: './date.component.html',
  styleUrls: ['./date.component.scss']
})
export class DateComponent extends NgxDateFilter implements OnInit {
  @Input() filter: Filter;
  @Input() options: FilterDateTimeOptions;
  @Input() label: string;
  @Input() value: Date;
  @Output() valueChange = new EventEmitter<Date>();

  ngOnInit(): void {
  }

}
